import { CustomerOrderProfitMarginView } from "src/api/generated/erp/db/types/tables/customerOrderProfitMarginView.ts";
import { CustomerOrderProfitMarginApi } from "src/api/generated/erp/sales/customerOrder/api/customerOrderProfitMarginApi.ts";
import { InlineCrudDataGrid } from "src/components/common/dataGrid/crud/InlineCrudDataGrid.tsx";
import { ClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/ClientSideDataGridModel.tsx";
import { getProfitMarginColumns } from "src/components/views/erp/sales/masterData/customerPriceGroups/CustomerPriceGroupProfitMarginsDataGrid.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import { useAavoToast } from "src/components/common/toast/AavoToastContext.tsx";
import i18n from "i18next";

export interface CustomerOrderProfitMarginsDataGridProps {
	customerOrderId: number;
	editable: boolean;
	onMarginsSaved: () => Promise<unknown>;
}

export function CustomerOrderProfitMarginsDataGrid({
	customerOrderId,
	editable,
	onMarginsSaved,
}: CustomerOrderProfitMarginsDataGridProps) {
	const { showToast } = useAavoToast();
	return (
		<ClientSideDataGridModel<
			CustomerOrderProfitMarginView[],
			CustomerOrderProfitMarginView,
			Record<string, never>
		>
			gridId={"D59C492BB7494BD2"}
			fetchData={() => CustomerOrderProfitMarginApi.getProfitMargins({ customerOrderId })}
			getRows={(data) => data}
			initialParams={{}}
			getRowId={(row) => row.salesPartPriceGroupId}
			render={({ dataGridProps, refreshData }) => (
				<InlineCrudDataGrid<CustomerOrderProfitMarginView>
					columns={getProfitMarginColumns<CustomerOrderProfitMarginView>()}
					save={
						editable ?
							{
								type: "enabled",
								action: async ({ items }) => {
									await CustomerOrderProfitMarginApi.saveProfitMargins({
										customerOrderId,
										rows: items,
									});
									showToast({
										title: i18n.t("profit_margins_saved"),
										message: i18n.t("profit_margins_saved_recalculation_required"),
									});
									await Promise.all([refreshData(), onMarginsSaved()]);
									return items;
								},
							}
						: { type: "hidden" }
					}
					agentContext={{
						key: defineAgentUiContextKey("erp.sales.customerOrder.profitMargins.grid"),
						data: { customerOrderId },
						rowFields: ["salesPartPriceGroupId", "salesPartPriceGroupName", "profitMarginPercent"],
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
}
